import { LoaderCircle } from 'lucide-react';

/** Transient step shown while the candidate file is read and validated. */
export const CheckingStep = () => (
  <div className="flex flex-col items-center justify-center gap-6 rounded-2xl border border-border p-16">
    <div className="flex size-10 items-center justify-center rounded-lg bg-muted">
      <LoaderCircle className="size-6 animate-spin text-foreground" />
    </div>
    <div className="flex flex-col items-center gap-2 text-center">
      <p className="text-lg font-medium tracking-tight text-foreground">
        Uploading your file...
      </p>
      <p className="text-sm text-muted-foreground">
        Checking dimensions and resolution...
      </p>
    </div>
  </div>
);
